<div class="catalog-products-container" data-testid="products-list">
  <div class="catalog-products" *ngIf="products.length; else noProducts">
    <app-selecteable-products-list
      [products]="products"
      [currencyControl]="currencyControl"
      [productsMetadata]="productsMetadata"
      [isLoadingMore]="isLoadingMore"
      [options]="{
        triggerPage: 'catalog-view',
        pricingRules
      }"
      [source]="source"
      (loadMore)="loadMore()"
    ></app-selecteable-products-list>
  </div>
  <ng-template #noProducts>
    <div class="no-data-container">
      <img src="assets/images/bloc-note.svg" alt="" />
      <span class="no-data-msg">
        {{ "Catalogs.new_catalog.products.add_products" | translate }}
      </span>
      <p
        class="no-data-desc"
        [innerHTML]="'Catalogs.new_catalog.products.no_products' | translate"
      ></p>
      <button
        class="action-btn clear-btn"
        *appHasPermission="submitPermission()"
        [style.color]="'#6449DB'"
        (click)="addNewProducts()"
        data-testid="add-product-btn"
      >
        {{
          "Catalogs.new_catalog.products.actions.select_manually" | translate
        }}
      </button>
    </div>
  </ng-template>
</div>
